import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable({providedIn:'root'})
export class TelecomService {
  private http=inject(HttpClient);
  readonly visible=signal(false);readonly admin=signal(false);readonly permissions=signal<string[]>([]);
  readonly base=environment.apiBaseUrl+'/telecom';
  async access(){
    try{const result=await this.get<{visible:boolean;admin:boolean;permissions:string[]}>('/access');this.visible.set(result.visible);this.admin.set(result.admin);this.permissions.set(result.permissions);return result;}
    catch{this.visible.set(false);this.admin.set(false);this.permissions.set([]);return {visible:false,admin:false,permissions:[]};}
  }
  can(permission:string){return this.permissions().includes('telecom.pilot')&&this.permissions().includes(permission);}
  get<T=any>(path:string){return firstValueFrom(this.http.get<T>(this.base+path));}
  post<T=any>(path:string,body:unknown={}){return firstValueFrom(this.http.post<T>(this.base+path,body));}
  patch<T=any>(path:string,body:unknown){return firstValueFrom(this.http.patch<T>(this.base+path,body));}
  async pdf(path:string,number=''){const blob=await firstValueFrom(this.http.get(this.base+path,{responseType:'blob'}));const url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;const n=String(number||'').replace(/[^A-Za-z0-9_-]/g,'_').slice(0,60);link.download='RingOffice-Invoice-'+(n||'pending')+'.pdf';link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);}
}
